/**
 * Permite injetar segredos em runtime (CI/CD ou index.html) sem commitá-los.
 * Antes do bootstrap, em `main.ts`, chame `mergeRuntimeSecretsIntoEnvironment(environment)`.
 *
 * Exemplo em index.html (servido pelo pipeline):
 * ```html
 * <script>window.__MILE_EXPRESS_RUNTIME_CONFIG__ = { apiOauthClientSecret: '...', fxRatesApiKey: '...' };</script>
 * ```
 */
export interface MileExpressRuntimeSecrets {
  apiOauthClientSecret?: string;
  fxRatesApiKey?: string;
}

declare global {
  interface Window {
    __MILE_EXPRESS_RUNTIME_CONFIG__?: MileExpressRuntimeSecrets;
  }
}

export function mergeRuntimeSecretsIntoEnvironment(env: {
  apiOauthClientSecret?: string;
  fxRatesApiKey?: string;
}): void {
  if (typeof window === 'undefined') {
    return;
  }
  const r = window.__MILE_EXPRESS_RUNTIME_CONFIG__;
  if (!r) {
    return;
  }
  if (r.apiOauthClientSecret != null && r.apiOauthClientSecret !== '') {
    env.apiOauthClientSecret = r.apiOauthClientSecret;
  }
  if (r.fxRatesApiKey != null && r.fxRatesApiKey !== '') {
    env.fxRatesApiKey = r.fxRatesApiKey;
  }
}
